export default function(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/querySelectorAll.js